import { render, staticRenderFns } from "./UniformDetailForm.vue?vue&type=template&id=50302888"
import script from "./UniformDetailForm.vue?vue&type=script&lang=js"
export * from "./UniformDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports